/* unplugin-vue-components disabled */var render, staticRenderFns
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"
import style0 from "./table-list.vue?vue&type=style&index=0&id=15b85a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b85a88",
  null
  
)

export default component.exports